import { getAssetUrl } from '@lighthouse/assets'
import { useSetAtom } from 'jotai'
import type { AnimationItem } from 'lottie-web'
import { useEffect, useLayoutEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import { AppPublishStateAtom } from '@/atoms/application/state'

interface PublishProgressProps {
    isComplete: boolean
    isPublish?: boolean
    onClose: () => void
}

export const PublishProgress = ({ isComplete }: PublishProgressProps) => {
    const animationRef = useRef<HTMLDivElement>(null)
    const lottieAnimationRef = useRef<AnimationItem | null>(null)

    const setAppPublishState = useSetAtom(AppPublishStateAtom)

    useLayoutEffect(() => {
        if (isComplete) {
            const el = animationRef.current
            if (!el) {
                return
            }

            ;(async function start() {
                const lottie = await import('lottie-web')
                lottieAnimationRef.current = lottie.default.loadAnimation({
                    container: el,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: getAssetUrl('lottie', 'celebrate.json')
                })

                lottieAnimationRef.current.addEventListener('complete', () => {
                    setAppPublishState({
                        isPublish: false,
                        isSuccess: false
                    })
                })
            })()
        }
    }, [isComplete, setAppPublishState])

    useEffect(() => {
        return () => {
            lottieAnimationRef.current?.destroy()
        }
    }, [])

    return createPortal(
        <div
            ref={animationRef}
            style={{
                pointerEvents: 'none',
                position: 'fixed',
                zIndex: 201,
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: 800,
                height: 800
            }}
        />,
        document.body
    )
}
